export default function Stats({ space, score }) {

    return (
        <div
            style={{
                width: '90vw',
                left: '5vw',
                height: '10vh',
                position: 'fixed',
                top: '3vh',
                zIndex: 1000,
            }}
        >
            <div style={{position: 'absolute', top: '0', left: '0', width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <img src="./assets/Space.svg" alt="" width={'100%'} />
                <div style={{position: 'absolute', left: '60%', width: '32%', textAlign: 'center', color: 'white', fontSize: '1.5em'}}>
                    {space}
                </div>
            </div>
            <div style={{position: 'absolute', top: '0', right: '0', width: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <img src="./assets/Points.svg" alt="" width={'100%'} />
                <div style={{textAlign: 'center', position: 'absolute', left: '0%', width: '60%', fontSize: '1.1em'}}>
                    {score + ' PTS'}
                </div>
                <div style={{position: 'absolute', left: '60%', width: '32%', textAlign: 'center', color: 'white', fontSize: '1.5em'}}>
                    S
                </div>
            </div>
        </div>
    );
}
